import { useSelector } from 'react-redux';
import { userPaths } from 'routes/constants/userPaths';

import { useLocation, useNavigate } from 'react-router-dom';

import SupportHeadset from 'assets/svgs/supportHeadset';

import { EndUserSupportFabAnchor, EndUserSupportFabButton } from 'styles/endUserSupportFab';

import {
  buildEndUserSupportFabNavigationState,
  shouldShowEndUserSupportFab,
} from './endUserSupportFab.data';

import type { RootState } from 'store/store';

/**
 * Floating Support entry for authenticated employee screens.
 * Opens Get in touch with “Need help?” title (no info subtitle) already set.
 * Visible only for profile_enhanced / deduction_setup_* outside onboarding & TPA.
 */
const EndUserSupportFab = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const profileState = useSelector((state: RootState) => state.auth.endUserProfileState);

  if (!shouldShowEndUserSupportFab(location.pathname, profileState)) {
    return null;
  }

  const handleClick = (): void => {
    navigate(userPaths.piiVerification, {
      state: buildEndUserSupportFabNavigationState(location.pathname, location.search),
    });
  };

  return (
    <EndUserSupportFabAnchor data-testid="end-user-support-fab-anchor">
      <EndUserSupportFabButton
        type="button"
        aria-label="Contact support"
        data-testid="end-user-support-fab"
        onClick={handleClick}
      >
        <SupportHeadset aria-hidden />
      </EndUserSupportFabButton>
    </EndUserSupportFabAnchor>
  );
};

export default EndUserSupportFab;
